export default "__VITE_ASSET__Bv5XbD9T__"